import { render, staticRenderFns } from "./InputJenisBarang.vue?vue&type=template&id=18a018b3&"
import script from "./InputJenisBarang.vue?vue&type=script&lang=js&"
export * from "./InputJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports